import React, { Component } from "react";

import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";

// import {
//   getVendorReviewById,
//   updateCustomerReview
// } from "../Services/VendorService";

// import AllReviews from "../Practitioner/Profile/Reviews/AllReviews/AllReviews";
// import Published from "../Practitioner/Profile/Reviews/Published/Published";
import ServiceBookings from "./ServiceBookings/ServiceBookings";
import ServiceFeedback from "./ServiceFeedback/ServiceFeedback";

class Tabs extends Component {
  state = {
    activeTab: "1",
    tableData: [],
    searchText: "",
    reply: ""
  };

  // handleReply = async _id => {
  //   console.log("handle reply");
  //   const tableData = [...this.state.tableData].map(element => {
  //     if (element._id === _id) {
  //       element.reply = this.state.reply;
  //       return element;
  //     }
  //     return element;
  //   });

  //   const data = {};
  //   data._id = _id;
  //   data.reply = this.state.reply;
  //   const { error } = await updateCustomerReview(data);
  //   if (!error) this.setState({ tableData });
  // };
  // e;
  // handleReject = async _id => {
  //   const data = {};
  //   data._id = _id;

  //   let tableData = [...this.state.tableData];

  //   tableData = tableData.map(element => {
  //     if (element._id === _id) {
  //       element.deleted = !element.deleted;
  //       data.deleted = element.deleted;
  //       return element;
  //     }
  //     return element;
  //   });

  //   const response = await updateCustomerReview(data);

  //   if (!response.error) this.setState({ tableData });
  // };

  // handleOnChange = e => {
  //   console.log(e.target.name, e.target.value);
  //   this.setState({ [e.target.name]: e.target.value });
  // };

  // handleSearch = async () => {
  //   const searchText = this.state.searchText.toLowerCase();
  //   if (!searchText) {
  //     let result = await getVendorReviewById(this.props.vendorId);
  //     result = result.data.data;
  //     return this.setState({
  //       tableData: result
  //     });
  //   }
  //   const data = [...this.state.tableData].filter(element => {
  //     return element.description.toLowerCase().search(searchText) !== -1
  //       ? element
  //       : null;
  //   });

  //   this.setState({ tableData: data });
  // };

  // handlePublishStatus = async index => {
  //   const tableData = [...this.state.tableData];
  //   tableData[index].published = !tableData[index].published;

  //   //data object
  //   const data = {};
  //   data._id = tableData[index]._id;
  //   data.published = tableData[index].published;

  //   //send request
  //   const response = await updateCustomerReview(data);
  //   if (!response.error) this.setState({ tableData });
  // };

  toggle = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  // componentDidMount = async () => {
  //   let result = await getVendorReviewById(this.props.vendorId);
  //   result = result.data.data;
  //   console.log("result is ", result);
  //   this.setState({
  //     tableData: result
  //   });
  // };

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" md="12" className="mb-4">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1"
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  Service Bookings
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2"
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  Service Feedback
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab} >
              <TabPane tabId="1">
                <ServiceBookings></ServiceBookings>
              </TabPane>
              <TabPane tabId="2">
                <ServiceFeedback></ServiceFeedback>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/views/BookedServices/BookedServices.jsx